import React from 'react';
import { Field } from 'react-form';
import PlacesAutocomplete /* , { geocodeByAddress, getLatLng } */ from 'react-places-autocomplete';
import UTMap from '../../UTMap';
import InfoButton from '../../InfoButton';

import styles from '../Input/Input.scss';

const LocationUncontrolled = props => (
    <Field field={props.field} validate={props.validate}>
        { fieldApi => {
            const {
                // field,
                // validate,
                id,
                inputProps,
                label,
                hiddenLabel,
                description,
                placeholder,
                handleChange,
                handleSelect,
                geocodeResults,
                showMap,
                hoverText,
                useDynamicOption,
                searchOptions,
                themeV3,
                'data-testid': dataTestId,
                // ...rest,
            } = props;

            const { value, error, warning, /* success, */ touched, setValue, setTouched } = fieldApi;

            // if value field value is int, switch to regions to allow zip code search
            const dynamicOptions = /^\d+$/.test(value) ? { types: ['(regions)'] } : {};

            const combinedSearchOpts = useDynamicOption
                ? {
                    ...dynamicOptions,
                    ...searchOptions,
                }
                : {
                    ...searchOptions,
                };

            return (
                <div className={`form-group ${(touched && error) && 'is-invalid'} ${description && 'description'} ${styles.formInput} ${themeV3 ? styles.themeV3 : ''}`}>
                    {!themeV3 && (
                        <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                            {label}
                            {hoverText && <InfoButton hoverText={hoverText} />}
                        </label>
                    )}
                    {description && (<small>{description}</small>)}
                    <div className="input-wrapper">
                        <PlacesAutocomplete
                            value={value}
                            onSelect={(location, placeId) => {
                                setValue(location);
                                if (handleSelect && placeId != null) {
                                    handleSelect(location, placeId);
                                }
                            }}
                            onChange={location => {
                                setValue(location);
                                if (handleChange) {
                                    handleChange(location);
                                }
                            }}
                            searchOptions={combinedSearchOpts}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div className="location-autocomplete-root">
                                    <input
                                        {...getInputProps({
                                            ...inputProps,
                                            className: `form-control ${inputProps.className} ${styles.formControl}`,
                                            placeholder,
                                            onBlur: e => {
                                                console.log('location onBlur');
                                                setTouched();
                                                if (inputProps.onBlur) {
                                                    inputProps.onBlur(e);
                                                }
                                            },
                                        })}
                                        data-testid={dataTestId || undefined}
                                    />
                                    <div className={`autocomplete-dropdown-container location-autocomplete-container`}>
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map((suggestion, i) => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                    })}
                                                    data-testid={`location.suggestion-${i}`}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                        {!!(suggestions?.length) && (
                                            <div className="powered-by-google" />
                                        )}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                        {/* <PlacesAutocomplete
                            inputProps={inputProps}
                            classNames={cssClasses}
                            options={useDynamicOption ? dynamicOptions : options}
                        /> */}
                        <div className="error-indicator" />
                        {themeV3 && (
                            <label htmlFor={id}>{label}</label>
                        )}
                    </div>
                    {touched &&
                        ((error && <div className="invalid-feedback">{error}</div>) ||
                        (warning && <div className="warning-feedback">{warning}</div>))}
                    {geocodeResults && showMap && (
                        <UTMap
                            lat={geocodeResults.lat}
                            lng={geocodeResults.lng}
                            placeName={value}
                            height="150px"
                        />
                    )}
                </div>
            );
        }}
    </Field>
);

const LocationControlled = (props) => {
    const {
        id,
        inputProps,
        label,
        hiddenLabel,
        description,
        placeholder,
        handleChange,
        handleSelect,
        geocodeResults,
        showMap,
        hoverText,
        useDynamicOption,
        searchOptions,
        value,
        themeV3,
        'data-testid': dataTestId,
    } = props;

    const dynamicOptions = /^\d+$/.test(value) ? { types: ['(regions)'] } : {};
    const combinedSearchOpts = useDynamicOption
        ? {
            ...dynamicOptions,
            ...searchOptions,
        }
        : {
            ...searchOptions,
        };

    return (
        <div className={`form-group form-group-xl ${description && 'description'} ${themeV3 ? styles.themeV3 : ''}`}>
            {!themeV3 && (
                <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                    {label}
                    {hoverText && <InfoButton hoverText={hoverText} />}
                </label>
            )}
            {description && (<small>{description}</small>)}
            <div className="input-wrapper">
                <PlacesAutocomplete
                    value={value}
                    onSelect={location => {
                        console.log('location onSelect', location);
                        if (handleSelect) {
                            handleSelect(location);
                        }
                    }}
                    onChange={location => {
                        console.log('location onChange', location);
                        if (handleChange) {
                            handleChange(location);
                        }
                    }}
                    searchOptions={combinedSearchOpts}
                >
                    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                        <div className="location-autocomplete-root">
                            <input
                                {...getInputProps({
                                    ...inputProps,
                                    className: `form-control ${inputProps?.className} ${styles.formControl}`,
                                    placeholder,
                                    onBlur: e => {
                                        console.log('location onBlur');
                                        if (inputProps.onBlur) {
                                            inputProps.onBlur(e);
                                        }
                                    },
                                })}
                                data-testid={dataTestId || undefined}
                            />
                            <div className={`autocomplete-dropdown-container location-autocomplete-container`}>
                                {loading && <div>Loading...</div>}
                                {suggestions.map((suggestion, i) => {
                                    const className = suggestion.active
                                        ? 'suggestion-item--active'
                                        : 'suggestion-item';
                                    return (
                                        <div
                                            {...getSuggestionItemProps(suggestion, {
                                                className,
                                            })}
                                            data-testid={`location.suggestion-${i}`}
                                        >
                                            <span>{suggestion.description}</span>
                                        </div>
                                    );
                                })}
                                {!!(suggestions?.length) && (
                                    <div className="powered-by-google" />
                                )}
                            </div>
                        </div>
                    )}
                </PlacesAutocomplete>
                {/* <PlacesAutocomplete
                    inputProps={inputProps}
                    classNames={cssClasses}
                    options={useDynamicOption ? dynamicOptions : options}
                /> */}
                <div className="error-indicator" />
                {themeV3 && (
                    <label htmlFor={id}>{label}</label>
                )}
            </div>
            {geocodeResults && showMap && (
                <UTMap
                    lat={geocodeResults.lat}
                    lng={geocodeResults.lng}
                    placeName={value}
                    height="150px"
                />
            )}
        </div>
    );
};

const Location = (props) => (
    props.controlled ? (
        <LocationControlled {...props} />
    ) : <LocationUncontrolled {...props} />
);

Location.defaultProps = {
    controlled: false,
};

export default Location;
